import { RootAppState } from 'store/configureStore'

export const headerFilteredRowsSelector =
  (bomItemId: string) =>
  (state: RootAppState): string[] => {
    const bomItem =
      (state.project.flatView && state.project.flatView[bomItemId]) ||
      (state.project.treeView && state.project.treeView[bomItemId])

    if (!bomItem) {
      return null
    }

    if (bomItem.type === 'Row') return null

    return bomItem.filteredPartTypeIds
  }
